import Modal from '@mui/material/Modal';
import dynamic from 'next/dynamic';
import { useDispatch, useSelector } from 'react-redux';
import {
  setPsychoQuizModal,
  setQuizModal,
  setTakeQuizModal,
} from '../../../store/slices/community/loveSlice';

const MdOutlineAssignment = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdOutlineAssignment)
);
const MdOutlinePeopleAlt = dynamic(() =>
  import('react-icons/md').then((mod) => mod.MdOutlinePeopleAlt)
);

const TakeQuizModal = () => {
  const lang = useSelector(({ common }) => common?.language);
  const dispatch = useDispatch();
  const takeQuizModal = useSelector(({ love }) => love?.takeQuizModal);

  const handleModalClose = () => {
    dispatch(setTakeQuizModal(false));
  };

  const handleGenericQuizModal = () => {
    dispatch(setQuizModal(true));
    dispatch(setTakeQuizModal(false));
  };

  const handlePsychoQuizModal = () => {
    dispatch(setPsychoQuizModal(true));
    dispatch(setTakeQuizModal(false));
  };

  return (
    <Modal
      className='flex items-center justify-center overflow-scroll'
      open={takeQuizModal}
      onClose={handleModalClose}
      aria-labelledby='simple-modal-title'
      aria-describedby='simple-modal-description'
    >
      <div className='w-full rounded-[2px] border border-[#EBEBEB] bg-white p-6 sm:w-[420px]'>
        <div className='flex items-center justify-between'></div>

        <div>
          <h6 className='mb-4 text-[#757575]'>
            {lang?.community?.select_a_quiz_type}:
          </h6>
          <div
            onClick={handleGenericQuizModal}
            className='generic-quiz-bg flex cursor-pointer flex-col items-center justify-center rounded border px-8 py-8 shadow-sm'
          >
            <MdOutlineAssignment className='h-[40px] w-[36px]' color='white' />
            {/* <Image src={generic_quiz_image} width={100} height={80} objectFit='cover' style={{borderRadius: '4px'}} /> */}
            <h3 className='mt-3 text-[22px] font-semibold text-white'>
              {lang?.community?.local_quiz}
            </h3>
            <p className='mt-2 text-sm text-white'>
              {lang?.community?.ans_some_generic_questions}
            </p>
          </div>
          <div
            onClick={handlePsychoQuizModal}
            className='psycho-quiz-bg mt-4 flex cursor-pointer flex-col items-center justify-center rounded-sm border px-8 py-8 shadow-sm'
          >
            <MdOutlinePeopleAlt className='h-[28px] w-[40px]' color='white' />
            {/* <Image src={psycho_quiz_image} width={100} height={80} objectFit='cover' style={{borderRadius: '4px'}} /> */}
            <h3 className='mt-3 text-[22px] font-semibold text-white'>
              {lang?.community?.all_city_quiz}
            </h3>
            <p className='mt-2 text-sm text-white'>
              {lang?.community?.test_your_personality}
            </p>
          </div>
          <div className='mt-4'>
            <button
              onClick={() => dispatch(setTakeQuizModal(false))}
              className='font-semibold text-black'
            >
              {lang?.common?.cancel}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default TakeQuizModal;
